import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const SimpleLiveScopeXRLVS62 = () => {
  console.log('🎯 SimpleLiveScopeXRLVS62 component loading');
  
  const product = findProductById("livescope-xr-lvs62");
  
  if (!product) {
    console.error('Product not found:', "livescope-xr-lvs62");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="livescope-xr-lvs62"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default SimpleLiveScopeXRLVS62; 